export default "__VITE_ASSET__CWXeyqhZ__"